import React from "react";
import moment from 'moment';
import i18n from '../../../../lib/i18n/index.js';

class RadioQuestion extends React.Component {
  render() {
    var style = {marginBottom: "1em", "color": "#707070"};
    var ageRestrictionShow = true;
    const currentLanguage = i18n.language;

    if (this.props.data.agerestrict !== "") {
      ageRestrictionShow = false;
      const restrictDob = moment(this.props.dob).format('YYYY-MM-DD');

      if (restrictDob !== "Invalid date") {
        var a = moment();
        var diff = a.diff(restrictDob, 'years');
        if (diff <= this.props.data.agerestrict) {
          ageRestrictionShow = true;
        }
      }
    }

    if (this.props.data.condition === 4 || this.props.data.condition === 5 || this.props.data.condition === 6 || this.props.data.condition === 7) {
      style = {
        margin: "auto",
        marginTop: "10px",
        marginBottom: "1em"
      };
    }

    var required = this.props.data.required === 1 ? "*" : "";
    const questionText = currentLanguage === 'es' && this.props.data.question_translated
      ? this.props.data.question_translated
      : this.props.data.question;
    const groupName = `question-${this.props.data.id}`;

    return (
      ageRestrictionShow ? <div id="radioInput" className="col-sm-10 col-md-8" style={style}>
        <h6 className="radio-questions-title">
          {questionText}
          {required}
        </h6>
        {/* role=radiogroup + shared `name` make this a single, arrow-navigable
            group; each label is associated and Enter selects (a11y). */}
        <div className="radio-questions" role="radiogroup" aria-label={questionText}>
          {(currentLanguage === 'es' && this.props.data.answers_translated
            ? this.props.data.answers_translated
            : this.props.data.answers).map((ele, i) => {
              const optionId = `${groupName}-option-${i}`;
              return (
                <div className="radio" key={i}>
                  <input
                    id={optionId}
                    name={groupName}
                    type="radio"
                    value={ele}
                    checked={this.props.state[groupName] === ele}
                    onChange={this.props.onChange}
                    onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); e.currentTarget.click(); } }}
                    style={{ "marginRight": "10px" }}
                  />
                  <label style={{ color: "#707070" }} htmlFor={optionId}>{ele}</label>
                </div>
              );
          })}
        </div>
      </div> : <div></div>
    );
  }
}

export default RadioQuestion;
